const initMenuBar = () => {
  const menu_title = document.querySelectorAll('button.menuParent');
  menu_title.forEach((element) => {
    element.addEventListener('mouseover', (e) => {
      const menu_list = e.currentTarget.nextElementSibling;
      const first_sub_menu = menu_list.querySelector('.hoverItem');
      first_sub_menu.classList.add('bg-neutral-2.5');
      handleHoverItem(first_sub_menu);
    });
  });
  const elements_hover = document.getElementsByClassName('hoverItem');
  Array.from(elements_hover).forEach((element) => {
    element.addEventListener('mouseover', (e) => handleHoverItem(e.target));
  });
};
function handleHoverItem(element) {
  const listCurrentSubMenu =
    element.parentElement.querySelectorAll('.hoverItem');
  listCurrentSubMenu.forEach((currElement) => {
    if (currElement != element) {
      currElement.classList.remove('bg-neutral-2.5');
    } else currElement.classList.add('bg-neutral-2.5');
  });
  const title = element.innerText;
  const child_elements =
    element.parentElement.nextElementSibling.querySelectorAll(
      `.parent-title, .item-child`
    );
  child_elements.forEach((child_element) => {
    if (child_element.getAttribute('data-parent') != title) {
      child_element.classList.add('hidden');
    } else {
      child_element.classList.remove('hidden');
    }
  });
}
document.addEventListener('DOMContentLoaded', initMenuBar);
